export const ProjectReasonsForCancellation = [
  'Project created in error',
  'Duplicate project',
  'Project is no longer necessary',
  'Other',
];
